import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import PromoBanner from '../Components/PromoBanner';
import Navbar from '../Components/Navbar';
import Slider from '../Components/SliderAllCategories';
import Products from '../Components/Products';
import Sample from '../Components/Sample';
import Subscribe from '../Components/SubscribeSection';
import FixedImageMessage from '../Components/FixedImageMessage';
import Footer from '../Components/Footer';
import add from '../Images/add-square.png';

const ProductCard = ({ product, onClick }) => {
  return (
    <div className="flex flex-col items-start bg-white rounded-lg shadow-lg mx-2 my-2 cursor-pointer" onClick={onClick}>
      <div className="w-full">
        <img src={product.image} alt={product.name} className="w-full h-auto object-cover mb-4" />
      </div>
      <div className="text-start pl-5">
        <h3 className="text-md mb-2" style={{ fontFamily: 'arial' }}>{product.name}</h3>
        <p className="text-xs mr-2 mb-7" style={{ fontFamily: 'arial', color: '#8C8C8C' }}>{product.description}</p>
        <div className="flex flex-row items-center justify-between mb-5 gap-10">
          <p className=" " style={{ fontFamily: 'arial', fontSize: '13px' }}>From £{product.min_price}</p>
          <div className="flex flex-row items-center gap-2">
            <p style={{ color: '#EC008C', fontFamily: 'arial', fontSize: '13px' }}>
              Shop Now
            </p>
            <button>
              <img src={add} className="w-4 h-4 mr-2" alt="Add" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const CollectionPage = () => {
  const location = useLocation();
  const promoBannerRef = useRef(null);
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  useEffect(() => {
    if (location.state?.scrollToPromo && promoBannerRef.current) {
      window.scrollTo({
        top: promoBannerRef.current.offsetTop,
        behavior: 'smooth',
      });
    }
  }, [location]);
  useEffect(() => {
    const fetchCategories = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get('https://backend.printtrio.co.uk/api/category/get-category');
        const sortedCategories = response.data.data
          .filter(cat => cat.is_active === 1) 
          .sort((a, b) => a.ordering - b.ordering);
  
        setProducts(sortedCategories);
      } catch (error) {
        console.error('Error fetching categories:', error);
      } finally {
        setIsLoading(false);   // ← turn off spinner no matter what
      }
    };
  
    fetchCategories();
  }, []);
  

  const handleCategoryClick = (categoryId, categoryName, banner, description) => {
    navigate('/Category-name', { state: { categoryId, categoryName, banner, description, scrollToPromo: true } });
  };
  
  

  return (
    <div>
      <div ref={promoBannerRef}>
        <PromoBanner />
      </div>
      <Navbar />
      {isLoading ? (
      <div className="flex justify-center items-center h-screen">
        {/* simple Tailwind spinner */}
        <svg
          className="animate-spin h-12 w-12 text-pink-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          />
        </svg>
      </div>
    ) : (
      <>
      <Slider />
      <div className="flex flex-col bg-gray-100 py-12 px-2 md:px-16 xl:px-48 max-w-screen-2xl mx-auto px-4 xl:px-20 relative">
        <div className="relative mt-10">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-2">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onClick={() => handleCategoryClick(product.id, product.name, product.banner, product.description)}             />
            ))}
          </div>
        </div>
      </div>
      
      <Products />
      <Sample />
      <Subscribe />
      <FixedImageMessage />
      <Footer />
      </>
       )}
    </div>
  );
};

export default CollectionPage;
